import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import PropTypes from 'prop-types';

import Datatable, { RELOAD_TABLE_TIME } from '../../components/Datatable/';

import {
  getAllBreeds,
  removeBreeds,
  restoreBreeds
} from '../../redux/actions/breeds';
import TableHeader from '../../components/TableHeader';
import ModalRemoveItem from '../../components/ModalRemoveItem';
import ModalRestoreItem from '../../components/ModalRestoreItem';
import searchForPermissions from '../../utils/searchForPermissions';

function List (props) {
  const breeds = useSelector(state => state.breeds);
  const dispatch = useDispatch();
  const sessionUser = useSelector(state => state.authentications.user);
  const company = sessionUser.company._id;
  const currentPermissions = searchForPermissions(
    'submenu',
    props.match.path,
    sessionUser.permissionsGroup.permissions
  );
  const [showTable, setShowTable] = useState(true);
  useEffect(() => {
    if (showTable) {
      setShowTable(false);
      setTimeout(() => setShowTable(true), RELOAD_TABLE_TIME);
    }
  }, [currentPermissions.options]);
  const tableData = breeds.data.filter(
    item => item.active || currentPermissions.options.r
  );
  const [showModalRemove, setShowModalRemove] = useState(false);
  const [idItemWillRemove, setIdItemWillRemove] = useState('');
  const [nameItemWillRemove, setNameItemWillRemove] = useState('');
  const handleModalConfirmYesRemove = id => {
    setShowModalRemove(false);
    dispatch(removeBreeds(id));
  };
  const [showModalRestore, setShowModalRestore] = useState(false);
  const [idItemWillRestore, setIdItemWillRestore] = useState('');
  const [nameItemWillRestore, setNameItemWillRestore] = useState('');
  const handleModalConfirmYesRestore = id => {
    setShowModalRestore(false);
    dispatch(restoreBreeds({ _id: id, active: true }));
  };

  useEffect(() => {
    dispatch(getAllBreeds({ company }));
  }, [dispatch]);

  const columns = [
    {
      title: 'Nome',
      data: 'name',
      render: data => data || '---'
    },
    {
      title: 'Espécie',
      data: 'specie.name',
      render: data => data || '---'
    },
    {
      title: 'Ações',
      data: '_id',
      orderable: false,
      className: 'no-export',
      render: (data, type, obj) => {
        return `
          <div class="btn-group">
          ${
            !(currentPermissions.options.l && currentPermissions.options.u)
              ? ''
              : `<button id="${data}" type="button" title="Editar" class="btn btn-warning button-action button-action-update rounded"><i class="fa fa-edit"></i></button>`
          }
          ${
            !obj.active ||
            !(currentPermissions.options.l && currentPermissions.options.d)
              ? ''
              : `<button id="${data}" type="button" title="Excluir" class="btn btn-danger button-action button-action-delete m-1 rounded"><i class="fa fa-trash"></i></button>`
          }
          ${
            obj.active ||
            !(currentPermissions.options.l && currentPermissions.options.r)
              ? ''
              : `<button id="${data}" type="button" title="Restaurar" class="btn btn-info button-action button-action-restore m-1 rounded"><i class="fas fa-trash-restore-alt"></i></button>`
          }
          </div>`;
      }
    }
  ];

  const buttons = [
    {
      extend: 'copy',
      className: 'btn btn-dark fa fa-copy',
      title: 'Relatorio Copiado',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'excel',
      className: 'btn btn-dark fa fa-file-excel',
      title: 'Relatorio Excel',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'csv',
      className: 'btn btn-dark fa fa-file-csv',
      title: 'Relatorio CSV',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'pdf',
      className: 'btn btn-dark fa fa-file-pdf',
      title: 'Relatorio PDF',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'print',
      className: 'btn btn-dark fa fa-file',
      title: 'Relatorio Print',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    }
  ];

  const handleUpdateButton = id => {
    const url = '/breeds/edit/' + id;
    dispatch(push(url));
  };

  const handleDeleteButton = dataRow => {
    setNameItemWillRemove(dataRow.name);
    setIdItemWillRemove(dataRow._id);
    setShowModalRemove(true);
  };

  const handleRestoreButton = dataRow => {
    setNameItemWillRestore(dataRow.name);
    setIdItemWillRestore(dataRow._id);
    setShowModalRestore(true);
  };

  return (
    <div className="container-fluid">
      <ModalRemoveItem
        showModal={showModalRemove}
        handleModalClose={() => setShowModalRemove(false)}
        handleModalConfirmYes={() =>
          handleModalConfirmYesRemove(idItemWillRemove)
        }
        titleModal={'Confirmação'}
        bodyModal={'Deseja excluir a raça'}
        nameItemWillRemove={nameItemWillRemove}
      />
      <ModalRestoreItem
        showModal={showModalRestore}
        handleModalClose={() => setShowModalRestore(false)}
        handleModalConfirmYes={() =>
          handleModalConfirmYesRestore(idItemWillRestore)
        }
        titleModal={'Confirmação'}
        bodyModal={'Deseja restaurar a raça'}
        nameItemWillRestore={nameItemWillRestore}
      />
      <TableHeader
        title={'Raças'}
        url={'/breeds/add'}
        updateList={() => dispatch(getAllBreeds({ company }))}
        isFetching={breeds.isFetching}
        hideAddButton={!currentPermissions.options.c}
        hideUpdateButton={!currentPermissions.options.l}
      />
      {showTable && currentPermissions.options.l && (
        <Datatable
          data={tableData}
          columns={columns}
          buttons={buttons}
          handleUpdateButton={handleUpdateButton}
          handleDeleteButton={handleDeleteButton}
          handleRestoreButton={handleRestoreButton}
        />
      )}
    </div>
  );
}

List.propTypes = {
  match: PropTypes.object
};

export default List;
